import React from 'react';
import PropTypes from 'prop-types';

export const Excel = ({ width, height, ...props }) => (
  <svg
    data-icon='excel'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='#207245'
      d='M12.414 3h1.215v1.674c2.046 0 4.093.005 6.14-.006.346.015.726-.01 1.026.201.21.31.186.703.2 1.06-.01 3.633-.005 7.264-.003 10.895-.01.61.055 1.231-.07 1.832-.082.435-.593.446-.934.46-2.119.006-4.239-.004-6.36 0V21h-1.27C9.244 20.42 6.12 19.884 3 19.326V4.676C6.139 4.119 9.277 3.568 12.414 3Z'
    />
    <path
      fill='white'
      d='M13.629 5.302h6.747v13.186H13.63v-1.255h1.635v-1.466H13.63v-.837h1.635v-1.465H13.63v-.837h1.635v-1.465H13.63v-.837h1.635V8.86H13.63v-.837h1.635V6.558H13.63V5.302Z'
    />
    <path
      fill='#207245'
      d='M16.082 6.558h2.863v1.465h-2.863V6.558Z'
    />
    <path
      fill='white'
      d='M9.057 8.52c.462-.034.926-.064 1.39-.087a439.452 439.452 0 0 1-1.65 3.43c.562 1.173 1.137 2.337 1.701 3.509-.492-.03-.984-.061-1.476-.097-.348-.872-.771-1.716-1.02-2.628-.279.85-.675 1.651-.994 2.484a48.192 48.192 0 0 1-1.344-.044c.526-1.053 1.033-2.114 1.575-3.16-.46-1.078-.965-2.135-1.44-3.207l1.35-.08c.304.82.637 1.627.89 2.466.269-.89.672-1.726 1.018-2.587Z'
    />
    <path
      fill='#207245'
      d='M16.082 8.86h2.863v1.466h-2.863V8.86Zm0 2.303h2.863v1.465h-2.863v-1.465Zm0 2.302h2.863v1.465h-2.863v-1.465Zm0 2.302h2.863v1.466h-2.863v-1.466Z'
    />
  </svg>
);

Excel.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Excel.defaultProps = {
  width: 24,
  height: 24,
};
